export default "__VITE_ASSET__BfQh1uB4__"